import Path from "@core/FileProvider/Path/Path";
import isURL from "@core-ui/utils/isURL";
import {
	MarkdownSerializerState,
	type MarkSerializerSpec,
} from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import type { Mark, Node } from "@tiptap/pm/model";

// Mixable marks on the text of a plain URL are written outside it (`holdsNoMarks`); code cannot be.
const isPlainURL = (state: MarkdownSerializerState, link: Mark, parent: Node, index: number) => {
	const href = link.attrs.href;
	if (link.attrs.title || !/^\w+:/.test(href) || MarkdownSerializerState.escape(href) !== href) return false;
	const content = parent.child(index);
	if (!content.isText || content.text !== href) return false;
	if (content.marks.some((mark) => !mark.eq(link) && !state.marks[mark.type.name].mixable)) return false;
	if ((href as string).endsWith("-")) return false;
	if (index === parent.childCount - 1) return true;
	return !link.isInSet(parent.child(index + 1).marks);
};

const getLinkFormatter = (): MarkSerializerSpec => {
	return {
		open(state, mark, parent, index) {
			state.inAutolink = isPlainURL(state, mark, parent, index);
			return state.inAutolink ? "<" : "[";
		},
		close(state, mark) {
			const inAutolink = state.inAutolink;
			state.inAutolink = undefined;
			const isFile = mark.attrs?.isFile ?? false;
			const resourcePath =
				mark.attrs.resourcePath && mark.attrs.resourcePath !== "" ? new Path(mark.attrs.resourcePath) : null;
			const isUrl = isURL(resourcePath?.value);

			// With the extension: GitHub, VS Code and Obsidian do not resolve the extensionless form.
			// Reading still accepts it.
			const link: string =
				isFile || isUrl
					? (resourcePath?.value ?? "")
					: (resourcePath ?? mark.attrs.href) + (mark.attrs.hash ?? "");
			const title = mark.attrs.title ? ` "${mark.attrs.title.replace(/[\\"]/g, "\\$&")}"` : "";
			return inAutolink
				? ">"
				: `](${link.includes(" ") ? `<${link.replaceAll("<", "\\<").replaceAll(">", "\\>")}>` : link}${title})`;
		},
		holdsNoMarks: isPlainURL,
	};
};
export default getLinkFormatter;
